module.exports = __webpack_public_path__ + "static/media/jetson_one_render_13.f6e32f48.jpg";